import { render, staticRenderFns } from "./LaundryPermissionManagement.vue?vue&type=template&id=18a47bbe&scoped=true"
import script from "./LaundryPermissionManagement.vue?vue&type=script&lang=js"
export * from "./LaundryPermissionManagement.vue?vue&type=script&lang=js"
import style0 from "./LaundryPermissionManagement.vue?vue&type=style&index=0&id=18a47bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a47bbe",
  null
  
)

export default component.exports